export const AolLight = () => {
  return (
    <svg width="67" height="48" viewBox="0 0 67 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M36.6204 17.0016C31.0145 17.0016 26.7734 21.3133 26.7734 26.6546C26.7734 32.2856 31.1932 36.3078 36.6204 36.3078C42.0476 36.3078 46.4511 32.2856 46.4511 26.6546C46.4511 21.3133 42.2263 17.0016 36.6204 17.0016ZM36.6204 22.1017C39.0415 22.0856 41.0239 24.1287 41.0239 26.6546C41.0239 29.1645 39.0416 31.2077 36.6204 31.2077C34.1993 31.2077 32.2169 29.1645 32.2169 26.6546C32.2169 24.1288 34.1993 22.1017 36.6204 22.1017ZM64.6712 32.9285C64.6712 34.7948 63.1438 36.3071 61.2589 36.3071C59.374 36.3071 57.8466 34.7948 57.8466 32.9285C57.8466 31.0623 59.374 29.5499 61.2589 29.5499C63.1438 29.5499 64.6712 31.0623 64.6712 32.9286V32.9285ZM54.7381 35.6642H49.376V11.6924H54.7381V35.6642Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25391 35.6642L12.0033 11.6924H17.0406L26.6276 35.6642H19.8029L18.6655 32.2856H10.2159L9.07846 35.6642H2.25391ZM17.0406 27.2982H12.0033L14.522 19.2539L17.0406 27.2982Z"
        fill="black"
      />
    </svg>
  );
};
